var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12 16.0001C5.12 9.98412 9.984 5.12012 16 5.12012C22.016 5.12012 26.88 9.98412 26.88 16.0001C26.88 22.0161 22.016 26.8801 16 26.8801C9.984 26.8801 5.12 22.0161 5.12 16.0001ZM25.6 16.0001C25.6 10.6881 21.312 6.40012 16 6.40012C10.688 6.40012 6.40001 10.6881 6.4 16.0001C6.4 21.3121 10.688 25.6001 16 25.6001C21.312 25.6001 25.6 21.3121 25.6 16.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.912 21.312L20.224 16L14.912 10.688L15.808 9.79199L22.016 16L15.808 22.208L14.912 21.312Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 15.3601L21.12 16.6401L10.24 16.6401L10.24 15.3601L21.12 15.3601Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.4aad303076a0f7a5c07b7949a41ce12b.svg";
export { ForwardRef as ReactComponent };